/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Core Components
import { BaseComponent } from './component/base.component';
import { ContainerComponent } from './component/container.component';
import { ControlComponent } from './component/control.component';
import { ApplicationComponent } from './component/application.component';

// NGC Core Directives
import { BaseDirective } from './directive/base.directive';

// NGC Core Services
import { BaseService } from './service/base.service';
import { EventService } from './service/event.service';
import { HTTPService } from './service/http.service';
import { RestService } from './service/rest.service';

/**
 * NGC Core Module
 */

export class NgcCoreModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
